/**
 * @file community
 * @author wangzhuang
 */

import {GET_HELPAPI_GETTEXT} from '../actions/ActionTypes';

export function helpapiGettext(state = {}, action) {
    switch (action.type) {
        case GET_HELPAPI_GETTEXT:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/community.js